import { createSlice } from "@reduxjs/toolkit";
import { globalActions } from "../actions";

const initialState = {
	items: { dict: {}, list: [] },
};

const adminCategorySlice = createSlice({
	name: "adminCategory",
	initialState,
	reducers: {
		setAdminCategories: (state, action) => {
			const itemsAsList = action.payload;
			state.items.list = itemsAsList;
			state.items.dict = {};
			for (let i = 0; i < itemsAsList.length; i++) {
				const item = itemsAsList[i];
				state.items.dict[item.id] = item;
			}
		},
		addAdminCategory: (state, action) => {
			const item = action.payload;
			state.items.list.unshift(item);
			state.items.dict[item.id] = item;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(globalActions.logout, () => initialState);
	},
});

const getAdminCategoryItemsAsList = (state) => state.adminCategory.items.list;
const getAdminCategoryItemsAsDict = (state) => state.adminCategory.items.dict;

export { getAdminCategoryItemsAsList, getAdminCategoryItemsAsDict };

export default adminCategorySlice;
